const empresaSelecionadaKey = 'empresaSelecionada'

export const setEmpresaSelecionada = (empresaSelecionada) => {
  try {
    sessionStorage.setItem(empresaSelecionadaKey, JSON.stringify(empresaSelecionada))
    return empresaSelecionada
  } catch (err) {
    console.log(err);
    throw err
  }
}

export const removeEmpresaSelecionada = () => {
  try {
    sessionStorage.clear();
    localStorage.clear();
  } catch (err) {
    console.log(err);
    throw err
  }
}

export const getEmpresaSelecionada = () => {
  try {
    const item = sessionStorage.getItem(empresaSelecionadaKey)
    return item ? JSON.parse(item) : item
  } catch (err) {
    console.log(err);
    throw err
  }
}
